<button class="base-dismiss-button" title="Dismiss" (click)="onDismissClick()">
  <ems-base-icon iconName="times"></ems-base-icon>
</button>
